import { render, staticRenderFns } from "./MenuItemHorizontal.vue?vue&type=template&id=0ec27ad9&scoped=true&"
import script from "./MenuItemHorizontal.vue?vue&type=script&lang=js&"
export * from "./MenuItemHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemHorizontal.vue?vue&type=style&index=0&id=0ec27ad9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec27ad9",
  null
  
)

export default component.exports